import { makeLoader } from '~/utils/routing';
import {
  draftClaimLineItemContext,
  routeParamsSchema,
} from '../claimLineItemMiddleware';

export const { loader, useLoaderData } = makeLoader(({ context, params }) => {
  const draftClaimLineItem = context.get(draftClaimLineItemContext);
  const { claimType } = routeParamsSchema.parse(params);

  return { draftClaimLineItem, claimType };
});

export const shouldRevalidate = () => false;
